var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recommend-container"},[_c('div',{staticClass:"product-list"},_vm._l((_vm.list),function(item){return _c('a',{directives:[{name:"track",rawName:"v-track",value:([
        {
          act: 'show',
          params: {
            event_id: '101|013|02|077',
            sku_id: item.id
          }
        },
        {
          act: 'click',
          params: {
            event_id: '101|013|01|077',
            sku_id: item.id
          }
        }
      ]),expression:"[\n        {\n          act: 'show',\n          params: {\n            event_id: '101|013|02|077',\n            sku_id: item.id\n          }\n        },\n        {\n          act: 'click',\n          params: {\n            event_id: '101|013|01|077',\n            sku_id: item.id\n          }\n        }\n      ]"}],key:item.id,staticClass:"item",attrs:{"href":item.url}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.imgUrl),expression:"item.imgUrl"}],attrs:{"alt":""}}),_c('p',{staticClass:"name border1px"},[_vm._v(_vm._s(item.name))]),_c('div',{staticClass:"price"},[_c('span',{staticClass:"yen"},[_vm._v("¥")]),_c('span',[_vm._v(_vm._s(_vm._f("formatNumber")(item.salePrice)))])])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }